<template>

  <!-- Checkbox Field -->
  <q-field
    borderless
    :hint="hint"
    :value="value"
    :rules="rules"
    class="checkbox-field"
    :lazy-rules="lazyRules">

    <div
      slot="control"
      class="row items-center no-wrap">

      <q-checkbox
        required
        :label="label"
        :value="value"
        @input="input"
        class="q-checkbox--push-left q-mb-none q-mr-xs"/>

      <div>

        <slot
          name="label"/>

      </div>

    </div>

  </q-field>

</template>

<script>

  import InputMixin from '@src/mixins/input-mixin';

  export default {
    name: 'checkbox-field',
    mixins: [
      InputMixin,
    ],
    props: [
      'hint',
      'label',
      'value',
      'rules',
      'lazyRules',
    ],
  };

</script>

<style lang="scss">

  .checkbox-field {

    .q-checkbox {
      margin-bottom: 0;
    }

    .q-field__bottom {
      padding-top: 0;
      padding-left: 12px;
    }
  }

</style>
